export function canCollectMessage(message) {
  return message?.role === 'assistant' && Boolean(message.msgId)
}

export function nextCollectionAction(message) {
  return message?.isCollected ? 'uncollect' : 'collect'
}

export function eventBelongsToSession(eventSessionGuid, activeSessionGuid) {
  return Boolean(eventSessionGuid) && eventSessionGuid === activeSessionGuid
}

export function applyTerminalEvent(message, event) {
  // 本地 guid 只是渲染占位符，不可作为 HMS 的 expectedLastMessageId。
  const messageId = event.msgGuid || event.msgId || message.msgId || ''
  const existingContent = String(message.content || '')
  const content = existingContent.trim()
    ? existingContent
    : (event.message || existingContent)

  return {
    ...message,
    content,
    starting: false,
    finished: true,
    isLoading: false,
    isTooling: false,
    toolLabel: '',
    messageStatus: event.messageStatus || (event.type === 'cancelled' ? 'cancelled' : 'failed'),
    incomplete: Boolean(event.incomplete),
    ...(messageId ? { msgId: messageId, guid: messageId } : {}),
  }
}
